import { render } from "./PlantNotificationParks.vue?vue&type=template&id=335c6390"
import script from "./PlantNotificationParks.vue?vue&type=script&lang=js"
export * from "./PlantNotificationParks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__